export default __webpack_public_path__ + "static/media/64.5f584f3a.jpeg";